import React from 'react';

export const CampaignGreenIconSVG = ({ type }) => {
    let src = null

    if (type === "create") {
        src = "M18.375 19.625H14.625V18.375H18.375V14.625H19.625V18.375H23.375V19.625H19.625V23.375H18.375V19.625Z"
    }

    if (type === "edit") {
        src = "M23.5625 17.0781L20.9062 14.4531L21.7812 13.5781C22.0208 13.3385 22.3151 13.2188 22.6641 13.2188C23.013 13.2188 23.3073 13.3385 23.5469 13.5781L24.4219 14.4531C24.6615 14.6927 24.7865 14.9818 24.7969 15.3203C24.8073 15.6589 24.6927 15.9479 24.4531 16.1875L23.5625 17.0781ZM22.6562 18L16.0312 24.625H13.375V21.9688L20 15.3438L22.6562 18Z"
    }

    if (type === "later") {
        src = "M16.5 20.25C16.3229 20.25 16.1745 20.1901 16.0547 20.0703C15.9349 19.9505 15.875 19.8021 15.875 19.625C15.875 19.4479 15.9349 19.2995 16.0547 19.1797C16.1745 19.0599 16.3229 19 16.5 19C16.6771 19 16.8255 19.0599 16.9453 19.1797C17.0651 19.2995 17.125 19.4479 17.125 19.625C17.125 19.8021 17.0651 19.9505 16.9453 20.0703C16.8255 20.1901 16.6771 20.25 16.5 20.25ZM19 20.25C18.8229 20.25 18.6745 20.1901 18.5547 20.0703C18.4349 19.9505 18.375 19.8021 18.375 19.625C18.375 19.4479 18.4349 19.2995 18.5547 19.1797C18.6745 19.0599 18.8229 19 19 19C19.1771 19 19.3255 19.0599 19.4453 19.1797C19.5651 19.2995 19.625 19.4479 19.625 19.625C19.625 19.8021 19.5651 19.9505 19.4453 20.0703C19.3255 20.1901 19.1771 20.25 19 20.25ZM21.5 20.25C21.3229 20.25 21.1745 20.1901 21.0547 20.0703C20.9349 19.9505 20.875 19.8021 20.875 19.625C20.875 19.4479 20.9349 19.2995 21.0547 19.1797C21.1745 19.0599 21.3229 19 21.5 19C21.6771 19 21.8255 19.0599 21.9453 19.1797C22.0651 19.2995 22.125 19.4479 22.125 19.625C22.125 19.8021 22.0651 19.9505 21.9453 20.0703C21.8255 20.1901 21.6771 20.25 21.5 20.25ZM14.625 25.25C14.2812 25.25 13.987 25.1276 13.7422 24.8828C13.4974 24.638 13.375 24.3438 13.375 24V15.25C13.375 14.9062 13.4974 14.612 13.7422 14.3672C13.987 14.1224 14.2812 14 14.625 14H15.25V12.75H16.5V14H21.5V12.75H22.75V14H23.375C23.7188 14 24.013 14.1224 24.2578 14.3672C24.5026 14.612 24.625 14.9062 24.625 15.25V24C24.625 24.3438 24.5026 24.638 24.2578 24.8828C24.013 25.1276 23.7188 25.25 23.375 25.25H14.625ZM14.625 24H23.375V17.75H14.625V24Z"
    }

    if (!src) {
        return ""
    }

    return (
        <div>
            <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="4" width="30" height="30" rx="15" fill="#C4E3D1" />
                <rect x="4" y="4" width="30" height="30" rx="15" stroke="#EFF0EF" stroke-opacity="0.4" strokeWidth="8" />
                <path d={src} fill="#27AE60" />
            </svg>
        </div>
    );
};

